/* Gift card page (sections/gift-card-product.liquid).
   The form works without this file (a plain POST to /cart/add). This adds:
   the amount on the card and the button, the "someone else" fields (only
   enabled when chosen, so a hidden empty email never blocks checkout), the
   add through the theme's own cart call so the bag drawer opens as
   everywhere else, and the press-and-bounce card. */
(function () {
  var root = document.querySelector('[data-gc]');
  if (!root) return;
  var form = root.querySelector('[data-gc-form]');
  var idField = root.querySelector('[data-gc-id]');
  var cardAmt = root.querySelector('[data-gc-card-amt]');
  var cardFor = root.querySelector('[data-gc-card-for]');
  var btnAmt = root.querySelector('[data-gc-btn-amt]');
  var addBtn = root.querySelector('[data-gc-add]');
  var err = root.querySelector('[data-gc-err]');
  var to = root.querySelector('[data-gc-to]');
  var noteMe = root.querySelector('[data-gc-note-me]');
  var send = root.querySelector('[data-gc-send]');
  var email = root.querySelector('[data-gc-email]');
  var name = root.querySelector('[data-gc-name]');
  var msg = root.querySelector('[data-gc-msg]');
  var count = root.querySelector('[data-gc-count]');
  var offset = root.querySelector('[data-gc-offset]');
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- amount ---------- */
  function pop(el) {
    if (!el || still) return;
    el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
  }
  root.querySelectorAll('input[name="gc-amount"]').forEach(function (r) {
    r.addEventListener('change', function () {
      idField.value = r.value;
      var p = r.getAttribute('data-price');   /* USD face value, "$50 USD" */
      cardAmt.textContent = p; btnAmt.textContent = p;
      pop(cardAmt);
      /* other currencies: "You’ll pay about $72.69 CAD at checkout…" */
      var payAmt = root.querySelector('[data-gcpay-amt]'), payFace = root.querySelector('[data-gcpay-face]');
      if (payAmt && r.getAttribute('data-pay')) payAmt.textContent = r.getAttribute('data-pay');
      if (payFace) payFace.textContent = p;
    });
  });

  /* ---------- who it's for ---------- */
  var themFields = [send, email, name, msg, offset, root.querySelector('[data-gc-date]')];
  function setWho(them) {
    to.hidden = !them;
    noteMe.hidden = them;
    themFields.forEach(function (f) { if (f) f.disabled = !them; });
    send.checked = them;
    email.required = them;
    if (offset) offset.value = String(new Date().getTimezoneOffset());
    paintFor();
    if (them) email.focus({ preventScroll: true });
  }
  root.querySelectorAll('[data-gc-who]').forEach(function (r) {
    r.addEventListener('change', function () { setWho(r.value === 'them' && r.checked); });
  });
  function paintFor() {
    var n = !to.hidden && name.value.trim();
    cardFor.hidden = !n;
    cardFor.textContent = n ? 'For ' + n : '';
  }
  name.addEventListener('input', paintFor);
  msg.addEventListener('input', function () { count.textContent = msg.value.length; });

  /* ---------- add to bag ---------- */
  form.addEventListener('submit', function (e) {
    err.hidden = true;
    if (!to.hidden && !email.checkValidity()) {
      e.preventDefault();
      err.textContent = 'Add their email so we know where to send it.';
      err.hidden = false;
      email.focus();
      return;
    }
    var MS = window.MagicStore;
    if (!MS || !MS.addItems) return;           // plain form post instead
    e.preventDefault();
    var item = { id: Number(idField.value), quantity: 1 };
    if (!to.hidden) {
      var props = {};
      new FormData(form).forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') props[m[1]] = v;
      });
      item.properties = props;
    }
    var sentToSomeone = !to.hidden;
    Promise.resolve(MS.addItems([item], addBtn)).then(function (cart) {
      // addItems resolves the cart on success and null when Shopify refused;
      // only a successful add clears what was typed (Rich 10-03: the
      // "someone else" details stayed filled in after adding to the bag).
      if (cart && sentToSomeone) resetRecipient();
    });
  });

  function resetRecipient() {
    [email, name, msg, root.querySelector('[data-gc-date]')].forEach(function (f) { if (f) f.value = ''; });
    count.textContent = '0';
    var me = root.querySelector('[data-gc-who][value="me"]');
    if (me) me.checked = true;
    setWho(false);
  }

  /* The card presses, bounces and tilts through assets/gift-card-art.js
     (shared with the balance pages and the gift guide). */
})();

/* ---------- balance checker (#balance, only when a Storefront token is set) ----------
   Applies the typed code to a throwaway cart through Shopify's Storefront
   API and reads the card's balance back. Shopify validates the whole code
   and rate-limits; the cart is never checked out and nothing is stored. */
(function () {
  var form = document.querySelector('[data-gc-checker]');
  if (!form) return;
  var input = form.querySelector('[data-gc-checkcode]');
  var btn = form.querySelector('[data-gc-checkbtn]');
  var out = form.querySelector('[data-gc-checkout]');
  var token = form.getAttribute('data-token');
  var probe = form.getAttribute('data-probe');
  var domain = form.getAttribute('data-domain');
  var MUTATION = 'mutation($input: CartInput!) { cartCreate(input: $input) { cart { appliedGiftCards { lastCharacters balance { amount currencyCode } } } userErrors { message } } }';

  function say(html, kind) {
    out.className = 'gc__checkout' + (kind ? ' is-' + kind : '');
    out.innerHTML = html;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(m) {
    var n = Number(m.amount);
    try { return new Intl.NumberFormat('en-CA', { style: 'currency', currency: m.currencyCode, currencyDisplay: 'narrowSymbol' }).format(n) + ' ' + m.currencyCode; }
    catch (e) { return '$' + n.toFixed(2) + ' ' + m.currencyCode; }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = (input.value || '').replace(/[\s-]/g, '');
    if (code.length < 8) { say('Type the full code from your gift card email.', 'warn'); input.focus(); return; }
    if (!probe) { say('The checker isn’t available right now. Your balance is in your gift card email.', 'warn'); return; }
    btn.disabled = true; btn.textContent = 'Checking…'; say('');
    fetch('https://' + domain + '/api/2025-04/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: MUTATION, variables: { input: {
        lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + probe, quantity: 1 }],
        giftCardCodes: [code]
      } } })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var cart = res && res.data && res.data.cartCreate && res.data.cartCreate.cart;
        var cards = cart && cart.appliedGiftCards;
        if (cards && cards.length) {
          var c = cards[0];
          say('<b>' + esc(money(c.balance)) + '</b> left on the card ending ' + esc(c.lastCharacters) + '.<span>Enter the code at checkout to use it.</span>', 'ok');
          var onCard = document.querySelector('[data-gcbal-amt]');
          if (onCard) {
            var n = Number(c.balance.amount);
            onCard.textContent = '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0));
            onCard.classList.remove('is-pop'); void onCard.offsetWidth; onCard.classList.add('is-pop');
          }
        } else if (res && res.errors) {
          say('The checker isn’t answering right now. Your balance is also in your gift card email.', 'warn');
        } else {
          say('That code didn’t work. It may be mistyped, used up or expired. Check it against your email, or <a href="/pages/need-help">ask us</a>.', 'warn');
        }
      })
      .catch(function () { say('The checker isn’t answering right now. Your balance is also in your gift card email.', 'warn'); })
      .then(function () { btn.disabled = false; btn.textContent = 'Check balance'; });
  });
})();
